import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { NotificationService } from '@app/core/services/notification.service'
import { Observable, throwError } from 'rxjs'
import { catchError, map, tap } from 'rxjs/operators'
import { saveAs } from 'file-saver'

@Injectable({
  providedIn: 'root',
})
export class SharedAhuService {
  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
  ) {}

  deleteAhu(id: string): Observable<boolean> {
    return this.http.delete<HttpResponse<null>>(`./Api/ahu/${id}`).pipe(
      tap({
        next: () => {
          this.notificationService.success('UI.Success.DeleteAhu')
        },
      }),
      map(() => true),
      catchError(error => {
        this.notificationService.error('UI.Error.DeleteAhu')
        return throwError(error)
      }),
    )
  }

  downloadXMLExport = (id: string): void => {
    saveAs(`./Api/ahu/${id}/XML`)
  }
}
